<div class="rich-text-editor">
  <div #editorContainer class="rich-text-editor__container"></div>
</div>
